import { onlyDigits } from "@/Utils/Validators";

const CEP_API_URL = process.env.NODE_CEP_API_URL ?? "https://viacep.com.br/ws";

export interface CepAddress {
  cep: string;
  street: string;
  district: string;
  city: string;
  state: string;
}

interface ViaCepResponse {
  cep?: string;
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  erro?: boolean | string;
}

const asViaCepResponse = (data: unknown): ViaCepResponse | null =>
  data && typeof data === "object" ? (data as ViaCepResponse) : null;

export const fetchAddressByCep = async (
  cep: string
): Promise<CepAddress | null> => {
  const digits = onlyDigits(cep);
  if (digits.length !== 8) return null;

  try {
    const response = await fetch(`${CEP_API_URL}/${digits}/json/`);
    if (!response.ok) return null;

    const data = asViaCepResponse(await response.json());
    if (!data || data.erro) return null;

    return {
      cep: data.cep ?? digits,
      street: data.logradouro ?? "",
      district: data.bairro ?? "",
      city: data.localidade ?? "",
      state: (data.uf ?? "").toUpperCase(),
    };
  } catch {
    return null;
  }
};
